import { Text, api } from 'common';

import { BlockFreeSoloMultiAutocomplete } from '../../ConfigFields/Autocomplete/index';
import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../ConfigFields/Duration';
import { ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { BlockTextField } from '../../ConfigFields/TextField';

const LookbackDurationUnit = api.FlowDefinition.LookbackDurationUnit;
type LookbackDurationUnit = api.FlowDefinition.LookbackDurationUnit;

const MAX_DOCUMENT_LIMIT = 100;

const PATIENT_SOURCE_HELPER_TEXT = `Select which upstream block to pull Patient data from.`;

const TITLE_FILTERS_HELPER_TEXT = `Filter document list by Title.`;

const TYPE_FILTERS_HELPER_TEXT = `Filter document list by document type.`;

const DOCUMENT_LIMIT_HELPER_TEXT = `Designate an amount of documents to return.`;

const LOOKBACK_DURATION_HELPER_TEXT = `Designate a lookback time range for documents to return.`;

const ENCOUNTER_HELPER_TEXT = `Filter documents by encounter.`;

export function DocumentExtractFormFields() {
  return (
    <>
      <Text variant="heading5" bold>
        Patient
      </Text>
      <ParentBlockSelectField
        fieldName="config.patient.sourceBlockName"
        label="Patient Source"
        required
        helperText={PATIENT_SOURCE_HELPER_TEXT}
      />
      <BlockValueTemplateField
        fieldName="config.encounterId"
        label="Encounter ID"
        helperText={ENCOUNTER_HELPER_TEXT}
      />
      <Text variant="heading5" bold>
        Filters
      </Text>
      <BlockFreeSoloMultiAutocomplete
        fieldName="config.titleFilters"
        label="Title Filters"
        helperText={TITLE_FILTERS_HELPER_TEXT}
      />
      <BlockFreeSoloMultiAutocomplete
        fieldName="config.typeFilters"
        label="Type Filters"
        helperText={TYPE_FILTERS_HELPER_TEXT}
      />
      <BlockTextField
        fieldName="config.documentLimit"
        label="Document Limit"
        type="number"
        slotProps={{ htmlInput: { min: 1, max: MAX_DOCUMENT_LIMIT } }}
        required
        helperText={DOCUMENT_LIMIT_HELPER_TEXT}
      />
      <BlockDurationField
        fieldName="config.lookbackDuration"
        unitFieldNameSuffix="unit"
        allowedUnits={Object.values(LookbackDurationUnit)}
        valueHelperText={LOOKBACK_DURATION_HELPER_TEXT}
      />
    </>
  );
}
